import $ from 'jquery';

const duration = 150;

/**
 * @param {string} parentsClass
 */
const initToggler = (parentsClass) => {
  const parents = [...document.getElementsByClassName(parentsClass)];
  for (let index = 0; index < parents.length; index++) {
    const parent = parents[index];
    /**
    * @type {HTMLButtonElement}
    */
    const toggle = parent.querySelector('[data-toggle]');
    const less = toggle.dataset.labelLess;
    const more = toggle.dataset.labelMore;
    /**
    * @type {HTMLElement}
    */
    const toggler = parent.querySelector('[data-toggler]');

    $(toggler).on('on.zf.toggler', () => {
      $(toggler).slideDown(duration);
      parent.classList.add(`${parentsClass}--open`);
      if (less) toggle.textContent = less;
    })
    $(toggler).on('off.zf.toggler', () => {
      $(toggler).slideUp(duration);
      parent.classList.remove(`${parentsClass}--open`);
      if (more) toggle.textContent = more;
      toggle.focus();
    })

    // Force toggle to init with the correct position
    if (toggler.style.display !== 'none') {
      $(toggler).foundation('toggle');
    }
  }
}

window.addEventListener('load', () => {
  initToggler('search-filters__widget');
});
